export interface PlatformEnumOption {
  value: string;
  label: string;
}

export function enumLabel(
  options: PlatformEnumOption[] | undefined,
  value: string | null | undefined,
): string {
  if (!value) return "—";
  return options?.find((o) => o.value === value)?.label ?? value;
}
